import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  PredefinedList,
  UnifiedSearchParams,
  UnifiedSearchResponse,
} from '../../shared/models/search.models';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/api/unified-search`;

  /** GET /api/unified-search. Record type is sent as the API enum (0 incident, 1 investigation). */
  search(p: UnifiedSearchParams) {
    let params = new HttpParams()
      .set('recordType', p.recordType === 'incident' ? 0 : 1)
      .set('pageSize', p.pageSize ?? 10)
      .set('pageIndex', p.pageIndex ?? 0);

    if (p.predefinedListId) params = params.set('predefinedListId', p.predefinedListId);
    // Whole days: from the start of dateFrom to the end of dateTo (the API filters CreatedAt).
    if (p.dateFrom) params = params.set('dateFrom', `${p.dateFrom}T00:00:00`);
    if (p.dateTo) params = params.set('dateTo', `${p.dateTo}T23:59:59`);
    for (const id of p.programIds ?? []) params = params.append('programIds', id);
    for (const id of p.categoryIds ?? []) params = params.append('categoryIds', id);
    if (p.personId) params = params.set('personId', p.personId);

    return this.http.get<UnifiedSearchResponse>(this.base, { params });
  }

  /** GET /api/predefined-lists: saved searches, each for one record type. */
  getPredefinedLists() {
    return this.http.get<PredefinedList[]>(`${environment.apiUrl}/api/predefined-lists`);
  }
}
